import { getDropdownFun } from '../../../../api/infoAPI';
import errorHandle from '../../../../utils/errorHandle';

export const fetchVehicleDropdownData = async (type, name, setVehicleDropdownData) => {
    try {
        const filters = await getDropdownFun(type, name);
        const result = filters?.data?.dropdown.map((item) => ({
            text: item.displayName,
            seats: parseInt(item.name)
        }));
        setVehicleDropdownData(result);
    } catch (error) {
        errorHandle(error);
    }
};
